import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import * as bootstrap from 'bootstrap';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window._ = _;
window.$ = window.jQuery = $;
window.bootstrap = bootstrap;

const registerBootstrapJQueryPlugin = (name, BootstrapClass) => {
    if (!BootstrapClass || $.fn[name]) {
        return;
    }

    $.fn[name] = function (configOrMethod, ...args) {
        return this.each(function () {
            const instance = BootstrapClass.getOrCreateInstance(
                this,
                typeof configOrMethod === 'object' ? configOrMethod : undefined
            );

            if (typeof configOrMethod === 'string' && typeof instance[configOrMethod] === 'function') {
                instance[configOrMethod](...args);
            }
        });
    };
};

registerBootstrapJQueryPlugin('modal', bootstrap.Modal);
registerBootstrapJQueryPlugin('toast', bootstrap.Toast);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
